import React from 'react';

const UrbexIcon = (props) => {
  return (
    <img
      alt="Urbex"
      src="/static/images/icons/tourist_attractions/urbex.svg"
      {...props}
    />
  );
};

export default UrbexIcon;
